import { render, staticRenderFns } from "./searchFilmName.vue?vue&type=template&id=6b5e64ba&scoped=true&"
import script from "./searchFilmName.vue?vue&type=script&lang=js&"
export * from "./searchFilmName.vue?vue&type=script&lang=js&"
import style0 from "./searchFilmName.vue?vue&type=style&index=0&id=6b5e64ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e64ba",
  null
  
)

export default component.exports